<ex-app-menu-panel [isOpen]="isOpen" desktopMode="inline" (close)="close.emit()">

  <nav class="nav-menu__links">

    <!-- Main links -->
    @if(isAuthenticated()) {
      <a class="nav-menu__link" routerLink="/dashboard" routerLinkActive="active">
        <span i18n="@@header.navbar.dashboard">Dashboard</span>
      </a>
    }

    <a class="nav-menu__link" [href]="yummypetsUrl+'photos/kudos'">
      <span i18n="@@header.navbar.community">Community</span>
    </a>
    <a class="nav-menu__link" [href]="yummypetsUrl + 'voice'">
      <span i18n="@@header.navbar.voice">Voice</span>
    </a>
    <a class="nav-menu__link" routerLink="/">
      <span>Explorer</span>
    </a>

    <!-- Divider (mobile only) -->
    <hr class="nav-menu__separator">

    <!-- Secondary links -->
    <a class="nav-menu__link nav-menu__link--secondary" routerLink="/question-of-the-day" routerLinkActive="active">
      <span i18n="@@header.navbar.qod">Question on the week</span>
    </a>
    <a class="nav-menu__link nav-menu__link--secondary" routerLink="/shelters" routerLinkActive="active">
      <span i18n="@@header.navbar.shelters">Help for animal shelters</span>
    </a>

  </nav>

  @if(!isAuthenticated()) {
    <div class="nav-menu__cta">
      <a routerLink="/login" class="btn btn--ghost btn--sm"
        i18n="@@global.btn.login">Log in</a>
      <a routerLink="/signup" class="btn btn--primary btn--sm"
        i18n="@@global.btn.join">Sign up</a>
    </div>
  }

</ex-app-menu-panel>
